import { Link } from 'react-router-dom';
import { MapPin, Mail, Clock } from 'lucide-react';

export default function KontaktPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Kontakt
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
              Lassen Sie uns<br />ins Gespräch kommen.
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Sie haben Fragen zu asK-mi, möchten Förderer werden oder suchen Unterstützung? 
              Wir freuen uns auf Ihre Nachricht.
            </p>
          </div>
        </div>
      </section>

      {/* Kontaktmöglichkeiten */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] transition-colors">
              <Mail className="w-6 h-6 text-[#C4A962] mb-4" strokeWidth={1.5} />
              <h3 className="font-semibold text-gray-900 mb-2">E-Mail</h3>
              <a href="mailto:we@ask-mi.com" className="text-[#A8923F] hover:underline">
                we@ask-mi.com
              </a>
            </div>
            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] transition-colors">
              <MapPin className="w-6 h-6 text-[#C4A962] mb-4" strokeWidth={1.5} />
              <h3 className="font-semibold text-gray-900 mb-2">Adresse</h3>
              <p className="text-gray-600 text-sm">
                c/o SteamWork<br />
                Roonstr. 23 a<br />
                76137 Karlsruhe
              </p>
            </div>
            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] transition-colors">
              <Clock className="w-6 h-6 text-[#C4A962] mb-4" strokeWidth={1.5} />
              <h3 className="font-semibold text-gray-900 mb-2">Erreichbarkeit</h3>
              <p className="text-gray-600 text-sm">
                Wir antworten in der Regel innerhalb weniger Werktage per E-Mail.
              </p>
            </div>
          </div>

          {/* Treffen */}
          <div className="bg-[#FAF9F7] rounded-2xl p-8 md:p-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Wo finden Treffen statt?</h2>
            <p className="text-gray-600 mb-8">
              asK-mi arbeitet an verschiedenen Orten – flexibel und auf Ihre Bedürfnisse abgestimmt:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C4A962] mt-0.5 shrink-0" strokeWidth={1.5} />
                <div>
                  <span className="font-medium text-gray-900">Unser Office</span>
                  <p className="text-sm text-gray-500">c/o SteamWork, Karlsruhe</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C4A962] mt-0.5 shrink-0" strokeWidth={1.5} />
                <div>
                  <span className="font-medium text-gray-900">Coworking-Räume</span>
                  <p className="text-sm text-gray-500">SteamWork | Goodspace</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C4A962] mt-0.5 shrink-0" strokeWidth={1.5} />
                <div>
                  <span className="font-medium text-gray-900">Vor Ort</span>
                  <p className="text-sm text-gray-500">Bei Ihnen im Unternehmen</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C4A962] mt-0.5 shrink-0" strokeWidth={1.5} />
                <div>
                  <span className="font-medium text-gray-900">Online</span>
                  <p className="text-sm text-gray-500">Videogespräch nach Vereinbarung</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Folgen Sie uns</h2>
            <p className="text-gray-600">Bleiben Sie informiert über unsere Arbeit und Projekte.</p>
          </div>
          <div className="flex justify-center gap-6">
            <a 
              href="https://www.instagram.com/ask_stiftung/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white border border-[#E8E4DE] rounded-xl px-6 py-4 hover:border-[#C4A962] transition-colors"
            >
              <svg className="w-6 h-6 text-[#C4A962]" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span className="font-medium text-gray-900">Instagram</span>
            </a>
            <a 
              href="https://www.linkedin.com/company/ask-mi" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white border border-[#E8E4DE] rounded-xl px-6 py-4 hover:border-[#C4A962] transition-colors"
            >
              <svg className="w-6 h-6 text-[#C4A962]" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              <span className="font-medium text-gray-900">LinkedIn</span>
            </a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gray-900 text-white text-center">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-[42px] font-bold tracking-tight mb-6">
            Werden Sie Förderer.
          </h2>
          <p className="text-lg text-white/70 max-w-xl mx-auto mb-10">
            Unterstützen Sie junge Menschen aus dem neurodiversen Spektrum und ermöglichen Sie neue Perspektiven.
          </p>
          <Link 
            to="/foerderer-werden"
            className="inline-flex items-center gap-2 bg-[#C4A962] hover:bg-[#D4B972] text-gray-900 px-9 py-4 rounded-md font-semibold text-lg transition-all hover:-translate-y-0.5"
          >
            Förderer werden
          </Link>
        </div>
      </section>
    </div>
  );
}
